import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Block, DefaultText, FlexColumn, FlexRow, imageNotFound, SmallGrayText, SmallText } from '@guryou/html-components';
import { PROVIDER_GET_GENERAL_INFO, PROVIDER_LATEST_WIDGET, resetState } from '@guryou/redux';
import { printPrice } from '@guryou/utils/build/stringUtils';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';

const FallbackCardMedia = ({ image }) => {
  const [imgSrc, setImgSrc] = useState(image);
  const handleImageError = () => {
    setImgSrc(imageNotFound);
  };
  return <CardMedia component="img" style={{ height: '200px', padding: 0 }} src={imgSrc} onError={handleImageError}></CardMedia>;
};

const MyCard = ({ item, to }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();

  const handleLearnMore = () => {
    dispatch(resetState(PROVIDER_GET_GENERAL_INFO));
    dispatch(resetState(PROVIDER_LATEST_WIDGET));
    return history.push(`/${i18n.language}/provider/${item.providerId}`);
  };

  return (
    <FlexRow lg={3} md={4} xs={8}>
      <Card style={{ width: '100%' }}>
        <CardActionArea onClick={() => history.push(`/${to}/${item.id}`)}>
          <FallbackCardMedia image={item.imageUrl} />
          <FlexColumn padding={4} alignItems="start">
            <FlexRow margin={0} justifyContent="space-between" alignItems="center" marginBottom={4}>
              <Block
                margin={0}
                background={`#${item.groupColor}`}
                color="white"
                padding={0.8}
                paddingLeft={2}
                paddingRight={2}
                width="auto"
                borderRadius="25px"
                fontWeight={800}
                textTransform="uppercase"
              >
                {item.groupName}
              </Block>
              <SmallText fontWeight={800}>{printPrice(item.price)}</SmallText>
            </FlexRow>
            <DefaultText fontSize="1.4rem" fontWeight={800} marginLeft={0} marginTop={2} marginBottom={4}>
              {item.name}
            </DefaultText>
            <FlexColumn height="140px" maxHeight="140px" overflow="scroll">
              <SmallGrayText dangerouslySetInnerHTML={{ __html: item.description }}></SmallGrayText>
            </FlexColumn>
          </FlexColumn>
        </CardActionArea>
        <CardActions>
          <Button size="small" color="primary" onClick={handleLearnMore}>
            {t('VIDEO_COURSE_PAGE.learnMoreProvider')}
          </Button>
        </CardActions>
      </Card>
    </FlexRow>
  );
};

export default MyCard;
